module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.$http.options.root + '/images/alanpicture.jpg',
      "alt": "AlanAutos"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', [_vm._v("Contacto")]), _vm._v(" "), _c('div', [_vm._v("alanautos.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "normalDiv"
  }, [_c('div', [_vm._v("Propietario: Alan Rodriguez")]), _vm._v(" "), _c('div', [_vm._v("Telefono - Whatsapp: 849-525-0036")]), _vm._v(" "), _c('div', [_vm._v("Santo Domingo")]), _vm._v(" "), _c('div', [_vm._v("República Dominicana")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-013e7a48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013e7a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/Contact.vue
// module id = 102
// module chunks = 0